import { useSelector } from "react-redux";
import { SxProps } from "@mui/material";
import { useStoreDispatch } from "../../../../store/hooks";
import { topOffenderFilterSelector } from "../../../../store/filters/topoffender/selector";
import { selectedGeoRegionsSelector } from "../../../../store/api/admin/selectors";
import { IGeoRegion } from "../../../../store/api/admin/types";
import { IFilterSelectBox } from "../../../../components/Shared/Filter/types";
import { setSelectedAlarmType, setSelectedConfigStatus, setSelectedRegion, setSelectedStatus, setSelectedType } from "../../../../store/filters/topoffender/reducer";

export const useTopOffenderFilter = () => {
  const dispatch = useStoreDispatch();
  const filterState = useSelector(topOffenderFilterSelector);
  const selectedGeoRegions = useSelector(selectedGeoRegionsSelector) as IGeoRegion[];
  const selectedGeoRegionNames = selectedGeoRegions?.map((r: IGeoRegion) => r.name) || [];

  // Always pass geoRegion as a single key with a comma-separated string of regions
  let geoRegionList: string[] = [];
  if (filterState.selectedRegion) {
    geoRegionList = [filterState.selectedRegion];
  } else if (selectedGeoRegionNames.length > 0) {
    geoRegionList = selectedGeoRegionNames;
  }
  const geoRegionFilter = geoRegionList.length > 0 ? { geoRegions: geoRegionList.join(",") } : {};

  const regionOptions =
    selectedGeoRegionNames.map((name: string) => ({
      value: name,
      text: name,
    })).sort((a, b) => (a.text || "").localeCompare(b.text || ""));

  const filters: IFilterSelectBox[] = [
    {
      id: "region",
      label: "REGION",
      value: filterState.selectedRegion,
      setValue: setSelectedRegion,
      values: regionOptions,
      width: "140px",
    },
    {
      id: "type",
      label: "TYPE",
      value: filterState.selectedType,
      setValue: setSelectedType,
      values: [
        { value: "SCSN-9%", text: "SN" },
        { value: "CU-%", text: "CU" },
        { value: "SCSN-10000%", text: "RCP" },
        { value: "ME1200%", text: "RCP (ME1200)" },
      ],
      width: "120px",
    },
    {
      id: "status",
      label: "STATUS",
      value: filterState.selectedStatus,
      setValue: setSelectedStatus,
      values: [
        { value: "connected", text: "Connected" },
        { value: "disconnected", text: "Disconnected" },
      ],
      width: "120px",
    },
    // {
    //   id: "alarmType",
    //   label: "ALARM TYPE",
    //   value: filterState.selectedAlarmType,
    //   setValue: setSelectedAlarmType,
    //   values: [
    //     { value: "critical", text: "Critical" },
    //     { value: "major", text: "Major" },
    //     { value: "minor", text: "Minor" },
    //   ],
    //   width: "150px",
    // },
    {
      id: "configStatus",
      label: "CONFIG STATUS",
      value: filterState.selectedConfigStatus,
      setValue: setSelectedConfigStatus,
      // values: [
      //   { value: "synchronized", text: "Synchronized" },
      //   { value: "outOfSync", text: "Out of Sync" },
      // ],
      values: ["NA", "Synchronized", "Pending", "Commit_Error", "Resynchronizing", "Synchronization_Failed", "Offline"],
      width: "130px",
    },
  ];

  const formControlSx: SxProps = { minWidth: 100, marginRight: "10px" };

  return {
    dispatch,
    filters,
    formControlSx,
    geoRegionFilter, // use this in API payload
  };
};

export const useAlarmDataGrid = () => {

  const paperSx = {
    backgroundColor: "var(--card)",
    borderRadius: "calc(var(--radius) + 4px)",
    border: "1px solid var(--border)",
    padding: 2,
    height: "100%",
    overflow: "hidden",
  };

  const titleSx = {
    mx: 6,
    mt: 6,
    mb: 2,
    color: "var(--card-foreground)",
    fontWeight: "var(--font-weight-semibold, 600)",
  };

  const gridContainerSx = {
    width: "100%",
    height: 600,
  };

  return {
    paperSx,
    titleSx,
    gridContainerSx,
  }
}
